import React from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';

function ProbabilityDistribution({
  distribution,
  distributionMode,
  setDistributionMode,
  scaleMode,
  setScaleMode,
  distributionLoading,
}) {
  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      {/* Header with title and selectors */}
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
        mb={2}
      >
        <Typography variant='h6'>Probability Distribution</Typography>
        <Box display='flex' gap={2} mt={{ xs: 1, md: 0 }}>
          <FormControl size='small' sx={{ minWidth: 140 }}>
            <InputLabel>Show By</InputLabel>
            <Select
              value={distributionMode}
              label='Show By'
              onChange={(e) => setDistributionMode(e.target.value)}
            >
              <MenuItem value='prediction'>
                <Tooltip title='Show distribution based on model predictions'>
                  <span>Prediction</span>
                </Tooltip>
              </MenuItem>
              <MenuItem value='session'>
                <Tooltip title='Show distribution based on sessions'>
                  <span>Session</span>
                </Tooltip>
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl size='small' sx={{ minWidth: 140 }}>
            <InputLabel>Scale</InputLabel>
            <Select
              value={scaleMode}
              label='Scale'
              onChange={(e) => setScaleMode(e.target.value)}
            >
              <MenuItem value='linear'>Linear</MenuItem>
              <MenuItem value='log'>Logarithmic</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* Legend */}
      <Box display='flex' alignItems='center' gap={2} mb={2}>
        <Box display='flex' alignItems='center' gap={1}>
          <Box
            sx={{
              width: 14,
              height: 14,
              backgroundColor: '#9c27b0',
              borderRadius: '2px',
            }}
          />
          <Typography variant='body2'>Number of Predictions</Typography>
        </Box>
        <Typography variant='caption' color='text.secondary'>
          Showing distribution by {distributionMode}
        </Typography>
      </Box>

      {/* Chart */}
      {distributionLoading ? (
        <Box display='flex' justifyContent='center' p={5}>
          <CircularProgress />
        </Box>
      ) : distribution?.length > 0 ? (
        <ResponsiveContainer width='100%' height={300}>
          <BarChart
            data={distribution}
            margin={{ top: 10, right: 30, left: 50, bottom: 50 }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis
              dataKey='bucket'
              label={{
                value: 'Probability Range',
                position: 'bottom',
                offset: 10,
              }}
            />
            <YAxis
              scale={scaleMode === 'log' ? 'log' : 'linear'}
              width={60}
              label={{
                value: 'Number of Predictions',
                angle: -90,
                position: 'outsideLeft',
                dx: -50,
              }}
              domain={['auto', 'auto']}
            />
            <Tooltip
              formatter={(value) => [`${value}`, 'Count']}
              cursor={{ fill: 'rgba(0,0,0,0.1)' }}
            />
            <Bar dataKey='count' fill='#9c27b0' />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography>No Data Available</Typography>
      )}
    </Paper>
  );
}

export default ProbabilityDistribution;
